import StepSix from './StepSix';

export default StepSix;
